import { useDispatch, useSelector } from "react-redux";
import { SBAComboBox } from "../UiComponents/SBADropDown";
import { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { assignUserToRole, deleteUserRole, getRoles, getRoleUser ,getUsers } from "../../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import { sbaAxios } from '../utils/sbaAxios';
import { useRef } from "react";



export const RoleToUser = () => {

    const Gstate = useSelector((state) => state) || {};
    const tenantsData = Gstate?.AdminPermissions?.TenantData || [];

    const [rolesData, setRolesData] = useState([]);
    const [selectedRole, setSelectedRole] = useState();
    const [userList, setUserList] = useState([]);
    const [showDrawer, setShowDrawer] = useState(false);
    const [drawerTenant, setDrawerTenant] = useState();
    const [tenantUser, setTenantUser] = useState([]);
    const [saveUserList, setSaveUserList] = useState([]);
    const [render,setRender]=useState(true);
    const tenantUserRef = useRef();
    
    useEffect(() => {
        rolesListData();
        if(selectedRole)
        getUserRoles();
    }, [render]);

    const usersListData = async (TenantID) => {
        try {
            const response = await sbaAxios({
                url: `${getUsers}?tenantId=${TenantID}`,
                method: 'get',
            })             
           const data = response;
            const filterredData = data.filter(item => item.UserId != !userList.some(item2 => item.id === item2.id));
            setTenantUser(filterredData.map(item => (
                { ...item, addUser: false }
            )))
        } catch (error) {
            console.error("Error fetching usersListData from API:", error);
        }
    };
    const getUserRoles = () => {
        sbaAxios({
            url: `${getRoleUser}${selectedRole.RoleId}`,
            method: 'get',
        }).then(Response => { setUserList(Response)}).catch(error => { console.log(error, 'error loadidng user list') });
    }

    const roleDDchn = (e) => {
        setSelectedRole(e.value);
        sbaAxios({
            url: `${getRoleUser}${e.value.RoleId}`,
            method: 'get',
        }).then(Response => { setUserList(Response) }).catch(error => { console.log(error, 'error loadidng user list') });
    };

    const rolesListData = async () => {
        try {
            const response = await sbaAxios({
                url: `${getRoles}`,
                method: 'get',
            })
            const data = response;
            setRolesData(data);
        } catch (error) {
            console.error("Error fetching rolesListData from API:", error);
        }
    };
    const handleDeleteClick = (UserId, RoleId, UserName) => {
        sbaAxios({
            url: `${deleteUserRole}${RoleId},${UserId}`,
            method: 'get',
        }).then(()=>{
            toast.success(`${UserName} Deleted From the Role`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
        }).catch(()=>{
            toast.error("Error Occured while Operation", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
        })
        setRender(!render);
    };
    const DeleteButtonRenderer = (props) => {
        console.log(props, 'delete ')
       const UserId=props.data.UserId;
       const RoleId=props.data.RoleId;
       const UserName=props.data.UserName
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={()=>handleDeleteClick(UserId,RoleId,UserName)}
                ></i>
            </div>
        );
    };
    const UserGridDef = [
        { headerName: "User Name", field: "UserName", filter: "agTextColumnFilter" },
        { headerName: "Role Name", field: "RoleName", filter: "agTextColumnFilter" },
        {
            headerName: "Delete",
            field: "Delete",
            maxWidth: 100,
            cellRenderer: DeleteButtonRenderer,
        },
    ];
    const defaultColDef = {
        sortable: false,
        floatingFilter: true,
        suppressMovable: true,
        flex: 1,
    };
    const updateUser = () => {
        setShowDrawer(true);
        setTenantUser([]);
        setDrawerTenant({});
    }
    const CheckboxRenderer = (props) => {
        const isAddded = props.data.addUser;
        const UserData = props.data;
        return (
            <div className="actions-cell">
                <input type='checkbox' className="SBA_hand" checked={isAddded} onChange={(e) => {
                    setTenantUser(value => (value.map(item => {
                        if (item.UserId === UserData.UserId) {
                            return { ...item, 'addUser': e.target.checked }
                        }
                        else {
                            return { ...item }
                        }
                    }
                    )))
                }} />
            </div>
        );
    }
    const userColDef = [
        {
            headerName: '',
            field: 'addUser',
            cellRenderer: CheckboxRenderer,
            maxWidth: 80
        },
        { headerName: "User Name", field: "UserName", filter: "agTextColumnFilter" },
        { headerName: "Email", field: "Email", filter: "agTextColumnFilter" },
    ];
    const assignRole=()=>{
        let roleAssigned=true;
        if (tenantUserRef.current) 
        {
            const gridInstance = tenantUserRef.current.api;
            const allRowData = [];
            
            gridInstance.forEachNode(node => {
              allRowData.push(node.data);
            });    
            const filteredRow=(allRowData.filter(item=>item.addUser)).map(item=>{
                return {
                    "createdBy": 38,
                    "modifiedBy": 38,
                    "roleId": selectedRole.RoleId,
                    "roleName": selectedRole.RoleName,
                    "userId": item.UserId,
                    "userName": item.UserName,
                    "attributeId": 0,
                    "attrName": "string"
                  }
            });
            filteredRow.map(item => {
                sbaAxios({
                    url: `${assignUserToRole}`,
                    method: 'post',
                    data: item,
                }).then(response=>{
                    roleAssigned=true;
                })
            })
        };

        setShowDrawer(false);
        setTenantUser([]);
        setDrawerTenant({});
        setRender(!render);
        if(roleAssigned)
        {
            toast.success("User Assigned to Role", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
        }
    }
    return <>
        <div className="col-lg-4 mt-4">
            <label
                htmlFor="select-fund"
                className="mb-1 ms-2 fw-semibold fs-12"
            >
                Select Role
            </label>
            <SBAComboBox data={rolesData} value={selectedRole} onChange={roleDDchn} textField='RoleName' valueField='RoleId' />
        </div>
        <div className="row flex-wrap mt-4">
            {selectedRole && <div className="col-lg-4">
                <div className="header-container m-2 fs-12">
                    <b>Available User in {selectedRole.RoleName}</b>
                    <button className="p-sm-btn mx-1" onClick={updateUser}>
                        <i className="fa-solid fa-plus" /> Add User
                    </button>
                </div>
                <div className="ag-theme-alpine m-1 " style={{ height: 450 }}>
                    <AgGridReact
                        columnDefs={UserGridDef}
                        rowData={userList}
                        defaultColDef={defaultColDef}
                    />
                </div>
            </div>}
        </div>
        <SBADrawer
            open={showDrawer}
            setOpen={setShowDrawer}
            close={false}
            title={`Update User for ${selectedRole?.RoleName}`}
            size={'lg'}
        >
            <div style={{height:"80%"}}>
                <label className="header-container m-1">
                    <b>Tenant Name</b>
                </label>
                <div >
                    <SBAComboBox
                        data={tenantsData}
                        textField={'TenantName'}
                        valueField={'TenantId'}
                        className='w-75'
                        options={"0"}
                        popupSettings={{ className: 'modalDD' }}
                        value={drawerTenant}
                        onChange={(e) => { usersListData(e.value.TenantId); setDrawerTenant(e.value) }}
                    />
                </div>
                {drawerTenant && <>
                    <div className="ag-theme-alpine m-1 "  >
                        <AgGridReact
                            columnDefs={userColDef}
                            rowData={tenantUser}
                            defaultColDef={defaultColDef}
                            ref={tenantUserRef}
                            suppressScrollOnNewData={true}
                        />
                    </div>
                    <div className="mt-4">
                        <button className="s-sm-btn mx-1" onClick={()=>setShowDrawer(false)}>
                            Cancel
                        </button>
                        <button className="p-sm-btn mx-1" onClick={assignRole}>
                            Assign Role
                        </button>
                    </div>
                </>}
            </div>
        </SBADrawer>
    </>
}